import Home from "./Components/Home.svelte"
import Assessor from "./Components/Assessor.svelte"

import Legal from './Components/Legal.svelte'
import Name from './Components/Questions/Name.svelte'
import Age from './Components/Questions/Age.svelte'
import Sex from './Components/Questions/Sex.svelte'
import Residence from './Components/Questions/Residence.svelte'
import isVisitor from './Components/Questions/isVisitor.svelte'
import Symptom from './Components/Questions/Symptom.svelte'
import Exposure from './Components/Questions/Exposure.svelte'
import travelCity from './Components/Questions/TravelCity.svelte'

import Purpose from './Components/Questions/Visitor/Purpose.svelte'
import VisitCompany from './Components/Questions/Visitor/VisitCompany.svelte'

import IdNumber from './Components/Questions/IdNumber.svelte'
import Department from './Components/Questions/Department.svelte'
import Temperature from './Components/Questions/Temperature.svelte'

import Result from './Components/Result.svelte'
import Qr from './Components/Qr.svelte'

const routes = [
    {
        name: '/',
        component: Home,
    },
    {
        name: '/assessor',
        component: Assessor,
    },
    {
        name: '/legal',
        component: Legal,
    },
    {
        name: '/name',
        component: Name,
    },
    {
        name: '/age',
        component: Age,
    },
    {
        name: '/sex',
        component: Sex,
    },
    {
        name: '/residence',
        component: Residence,
    },
    {
        name: '/isVisitor',
        component: isVisitor,
    },
    {
        name: '/symptom',
        component: Symptom,
    },
    {
        name: '/purpose',
        component: Purpose,
    },
    {
        name: '/VisitCompany',
        component: VisitCompany,
    },
    {
        name: '/idNumber',
        component: IdNumber,
    },
    {
        name: '/department',
        component: Department,
    },
    {
        name: '/temperature',
        component: Temperature,
    },
    {
        name: '/exposure',
        component: Exposure,
    },
    {
        name: '/travelCity',
        component: travelCity,
    },
    {
        name: '/result',
        component: Result,
    },
    {
        name: '/qr',
        component: Qr,
    },
];

export { routes }